export default function BrandBar() {
  return (
    <header className="w-full bg-background-50">
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-20 pt-14 md:pt-20 pb-0">
        <h1 className="font-heading text-2xl md:text-3xl font-medium text-foreground-50 tracking-tight">
          (EILASA, UAB)
        </h1>
        <div className="mt-6 w-full h-px bg-foreground-50/10"></div>
      </div>
    </header>
  );
}